import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import { isNullable } from '@ipfabric/utils';

export const stumbleOnMissingMandatoryColumn = (
  tableData: Record<string, unknown>[],
  mandatoryColumns: string[],
) => {
  for (const row of tableData) {
    for (const key of mandatoryColumns) {
      if (isNullable(row[key])) {
        stumble(`Unexpected empty value in column '${key}'`);
        // avoid spamming stumbles for every row
        return;
      }
    }
  }
};
